/**
 * Handles CSRF tokens.
 */
class CSRFToken {

  constructor() {
    this.isFetching = false;
    this.tokenKey = 'csrf_token';
    this.callbacks = [];

    // Fetch current token if dom has token input(s)
    document.addEventListener('DOMContentLoaded', () => {
      if (document.querySelectorAll('input[name="token"]').length > 0) {
        this.fetchToken();
      }
    });
  }

  /**
   * Gets current csrf token from server.
   */
  fetchToken() {
    if (this.isFetching) {
      return;
    }
    this.isFetching = true;
    window.$.ajax({
      url: '/stage-ajax/token/'
    }).always((response) => {
      this.isFetching = false;
      if (response && response.token && response.token !== this.getToken()) {
        this.updateToken(response.token);
      }
    });
  }

  /**
   * Registers callback which is called when current token changes.
   *
   * @param {Function} callback Callback which receives new token as first argument.
   */
  onChange(callback) {
    if (typeof callback !== 'function') {
      return;
    }

    this.callbacks.push(callback);
  }

  /**
   * Get current token.
   *
   * @return {String|null} Current token.
   */
  getToken() {
    return window.localStorage.getItem(this.tokenKey);
  }

  /**
   * Updates current token.
   *
   * @param {String} token New token.
   */
  updateToken(token) {
    if (token) {
      window.localStorage.setItem(this.tokenKey, token);
      this.callbacks.forEach(callback => {
        callback(token);
      });
    }
  }

}

export default new CSRFToken();
